import React, { useContext, useEffect, useState } from "react";
import { Heading, RichTextEditor, SectionHeading } from "../../../components";
import Input from "../../../components/Input/Input";
import { ResumeContext } from "../../../contexts/resumeContext";
import { deleteIcon, Plus } from "../../../components/Icons/Icons";

function ProjectForm() {
  const newProjectBlock = {
    title: "",
    company: "",
    startDate: "",
    endDate: "",
    description: "",
  };

  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);

  const [projectDetails, setProjectDetails] = useState(
    Object.values(
      resumeInfo?.misc?.projects || { 0: { ...newProjectBlock } }
    ) || []
  );

  useEffect(() => {
    const miscSection = { ...resumeInfo.misc };
    miscSection["projects"] = projectDetails;

    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [projectDetails]);

  const handleChange = (e, ix) => {
    let projectDetailsArr = [...projectDetails];
    let projectDetailsObj = projectDetailsArr[ix];
    projectDetailsObj[e.target.name] = e.target.value;
    projectDetailsArr[ix] = projectDetailsObj;
    setProjectDetails(projectDetailsArr);
  };

  const addBlock = () => {
    let projectsArr = [...projectDetails, newProjectBlock];
    setProjectDetails(projectsArr);
  };

  const deleteBlock = (ix) => {
    const projectsArr = [...projectDetails];
    projectsArr.splice(ix, 1);
    setProjectDetails(projectsArr);
  };

  return (
    <div>
      <SectionHeading editable content="Projects" section="PRO" />
      {projectDetails.map((exp, ix) => (
        <div className="block" key={`ed_${ix}`}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="Project Title"
                name="title"
                onChange={(e) => handleChange(e, ix)}
                value={exp.title}
              />
            </div>
            <div className="col">
              <Input
                label="Company / Institution / Personal"
                name="company"
                onChange={(e) => handleChange(e, ix)}
                value={exp.company}
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <Input
                label="Start Date"
                name="startDate"
                type="month"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.startDate}
              />
            </div>
            <div className="col">
              <Input
                label="End Date"
                name="endDate"
                type="month"
                placeholder="MM/YYYY"
                onChange={(e) => handleChange(e, ix)}
                value={exp.endDate}
              />
            </div>
          </div>
          <div className="row">
            <RichTextEditor
              placeholder="• Use 2-3 bullets to describe your project"
              value={exp.description}
              onChange={(value) =>
                handleChange({ target: { name: "description", value } }, ix)
              }
            />
          </div>
        </div>
      ))}
      <button className="link" onClick={addBlock}>
        Add More Projects <Plus />
      </button>
    </div>
  );
}

export default ProjectForm;
